export function useHydratedFlag() {
  const isHydrated = ref(false);

  onMounted(() => {
    isHydrated.value = true;
  });

  return isHydrated;
}
